import { parsePhoneNumberFromString, validatePhoneNumberLength } from 'libphonenumber-js/min'
import isNil from 'lodash/isNil'
import { mixed } from 'yup'

import isPopulated from './isPopulated'

export const nameValidationRegex = /^[_A-z\-']*((\s)*[_A-z\-'])*$/i

export const phoneValidationTest = (name, countryCode) => {
  return {
    name: name || 'phoneNumberSchema',
    message: 'Please enter a valid phone number.',
    test(value) {
      let phoneNumberObj
      if (!isNil(value)) {
        const phoneValue = typeof value === 'string' ? value : value?.value
        // Skip validation if phone value is not populated
        if (!isPopulated(phoneValue)) {
          return true
        }

        try {
          phoneNumberObj = parsePhoneNumberFromString(String(phoneValue), countryCode && countryCode)
          // biome-ignore lint/correctness/noUnusedVariables: TODO
        } catch (err) {
          return false
        }

        try {
          const length = validatePhoneNumberLength(String(phoneValue))
          switch (length) {
            case 'TOO_SHORT':
              return this.createError({
                message: 'Phone number is too short',
              })
            case 'TOO_LONG':
              return this.createError({
                message: 'Phone number is too long',
              })
            case 'INVALID_LENGTH':
              return this.createError({
                message: 'Phone number is not a valid length',
              })
          }
        } catch {
          // validatePhoneNumberLength can throw for invalid input
          return this.createError({
            message: 'Phone number is invalid',
          })
        }

        // Check if phoneNumberObj exists before calling isValid
        if (phoneNumberObj && !phoneNumberObj.isValid()) {
          return this.createError({
            message: 'Phone number is invalid',
          })
        }

        if (
          typeof value !== 'string' &&
          phoneNumberObj &&
          phoneNumberObj.country &&
          phoneNumberObj.country !== value.countryCode
        ) {
          return this.createError({
            message: 'Phone number is invalid',
          })
        }

        return true
      } else {
        return true
      }
    },
  }
}

// biome-ignore lint/correctness/noUnusedVariables: TODO
export const makePhoneNumberValidationSchema = name => {
  const phoneNumberSchema = {
    schema: mixed().test(phoneValidationTest()),
  }

  return phoneNumberSchema
}
